import { Routes, Route } from "react-router-dom";

import CharacterSelectionPlayer from '../../Pages/Player/CharacterSelectionPlayer/CharacterSelectionPlayer';
import CharacterHpPlayer from '../../Pages/Player/CharacterHpPlayer/CharacterHpPlayer';
import ConfigurationPlayer from "../../Pages/Player/ConfigurationPlayer/ConfigurationPlayer";
import CustomisationCharacterPlayer from "../../Pages/Player/CustomizationCharacterPlayer/CustomizationCharacterPlayer";
import { CONFIG_PLAYER_SUFFIX, CUSTOMIZATION_PLAYER_SUFFIX, PV_PLAYER_SUFFIX } from "../../Services/routeNames";

export default function RoutesPlayer() {
    
    return (
        <div>
            <Routes>
                <Route index element={<CharacterSelectionPlayer />} />
                <Route path={PV_PLAYER_SUFFIX} element={<CharacterHpPlayer />} />
                <Route path={CONFIG_PLAYER_SUFFIX} element={<ConfigurationPlayer />} />
                <Route path={CUSTOMIZATION_PLAYER_SUFFIX} element={<CustomisationCharacterPlayer />} />
            </Routes>
        </div>
    );
}